// src/hooks/useGuidelines.js
import { useEffect, useState } from "react";
import { getApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

const useGuidelines = () => {
  const [data, setData] = useState(null);
  const fetchData = async () => {
    const response = await getApi(apiEndPoints.getGuidelines);
    if (response && response.status === 200) {
      setData(response.data[0]);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return {data};
};

export default useGuidelines;
